import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';

import { getUserLoginState } from '../../../shared/store/selectors/login';
import { BoxActions } from '../../../site-detail/store/actions/box.actions';
import { DeviceActions } from '../../../site-detail/store/actions/device.actions';
import { addPendingInterventionAction } from '../../../site-detail/store/actions/ui.actions';
import { getRawDevice, getUiProperty } from '../../../site-detail/store/selectors/device-detail';
import { buildPendingDeviceAction, buildPendingRebootAction } from '../../utils/build-pending-intervention-action';

@Injectable()
export class InterventionEffects {
    private readonly actions$ = inject(Actions);
    private readonly store = inject(Store);

    addPendingActionsAfterDeviceUpdateStarted$ = createEffect(() =>
        this.actions$.pipe(
            ofType(DeviceActions.deviceUpdateStarted),
            switchMap(({ command, pendingTask }) =>
                combineLatest([
                    this.store.select(getRawDevice(command.device.id)),
                    this.store.select(getUserLoginState),
                    this.store.select(getUiProperty(command.device.id, command.property.id)),
                ]).pipe(
                    take(1),
                    map(([device, installer, property]) =>
                        buildPendingDeviceAction(device, installer.id, pendingTask, command, property.formatter),
                    ),
                ),
            ),
            map((interventionAction) => addPendingInterventionAction({ interventionAction })),
        ),
    );

    addPendingInterventionWhenRebootBox$ = createEffect(() =>
        this.actions$.pipe(
            ofType(BoxActions.boxRebootStarted),
            switchMap(({ command, pendingTask }) =>
                combineLatest([
                    this.store.select(getRawDevice(command.device.id)),
                    this.store.select(getUserLoginState),
                ]).pipe(
                    take(1),
                    map(([device, installer]) => buildPendingRebootAction(device, installer.id, pendingTask, command)),
                ),
            ),
            map((interventionAction) => addPendingInterventionAction({ interventionAction })),
        ),
    );
}
